// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__y_078","dragIcon":"Choice_dragIcon__1JA7F","left":"Choice_left__2gduQ","input":"Choice_input__zqbif"};